module.exports = __webpack_public_path__ + "static/media/arrow-down.ae0e1430.svg";